export class AssignTaskToUser {
    public taskIDs: string[];
    public userID: string;
}
